import { IApiEntity } from 'entities/entity';
import { TFunction } from 'i18next';

// For codes, see: https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes
// and https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes
// The format needs to match the format used in snapshots so the visitor language can be matched to a template
export const SUPPORTED_LANGUAGES: IApiEntity[] = [
  { id: 'en', name: 'supportedLanguages:languages.english' },
  { id: 'en-AU', name: 'supportedLanguages:languages.english-au' },
  { id: 'en-CA', name: 'supportedLanguages:languages.english-ca' },
  { id: 'en-HK', name: 'supportedLanguages:languages.english-hk' },
  { id: 'en-SG', name: 'supportedLanguages:languages.english-sg' },
  { id: 'en-TW', name: 'supportedLanguages:languages.english-tw' },
  { id: 'en-GB', name: 'supportedLanguages:languages.english-uk' },
  { id: 'en-US', name: 'supportedLanguages:languages.english-us' },
  { id: 'fr', name: 'supportedLanguages:languages.french' },
  { id: 'fr-CH', name: 'supportedLanguages:languages.swiss-french' },
  { id: 'it', name: 'supportedLanguages:languages.italian' },
  { id: 'it-CH', name: 'supportedLanguages:languages.swiss-italian' },
  { id: 'es', name: 'supportedLanguages:languages.spanish' },
  { id: 'ar', name: 'supportedLanguages:languages.arabic' },
  { id: 'ca-ES', name: 'supportedLanguages:languages.catalan' },
  { id: 'zh', name: 'supportedLanguages:languages.chinese' },
  { id: 'zh-CN', name: 'supportedLanguages:languages.chinese-simplified' },
  { id: 'zh-TW', name: 'supportedLanguages:languages.chinese-traditional-tw' },
  { id: 'zh-HK', name: 'supportedLanguages:languages.chinese-traditional-hk' },
  { id: 'zh-Hant', name: 'supportedLanguages:languages.chinese-traditional-hant' },
  { id: 'zh-MO', name: 'supportedLanguages:languages.chinese-traditional-mo' },
  { id: 'hr', name: 'supportedLanguages:languages.croatian' },
  { id: 'cs', name: 'supportedLanguages:languages.czech' },
  { id: 'da', name: 'supportedLanguages:languages.danish' },
  { id: 'nl', name: 'supportedLanguages:languages.dutch' },
  { id: 'fi', name: 'supportedLanguages:languages.finnish' },
  { id: 'de', name: 'supportedLanguages:languages.german' },
  { id: 'de-CH', name: 'supportedLanguages:languages.swiss-german' },
  { id: 'el', name: 'supportedLanguages:languages.greek' },
  { id: 'et', name: 'supportedLanguages:languages.estonian' },
  { id: 'hu', name: 'supportedLanguages:languages.hungarian' },
  { id: 'id', name: 'supportedLanguages:languages.indonesian' },
  { id: 'ja', name: 'supportedLanguages:languages.japanese' },
  { id: 'ko', name: 'supportedLanguages:languages.korean' },
  { id: 'lv', name: 'supportedLanguages:languages.latvian' },
  { id: 'lt', name: 'supportedLanguages:languages.lithuanian' },
  { id: 'nb', name: 'supportedLanguages:languages.norwegian-bokmal' },
  { id: 'nn', name: 'supportedLanguages:languages.norwegian-nynorsk' },
  { id: 'pl', name: 'supportedLanguages:languages.polish' },
  { id: 'pt', name: 'supportedLanguages:languages.portuguese' },
  { id: 'pt-BR', name: 'supportedLanguages:languages.portuguese-br' },
  { id: 'ro', name: 'supportedLanguages:languages.romanian' },
  { id: 'ru', name: 'supportedLanguages:languages.russian' },
  { id: 'sk', name: 'supportedLanguages:languages.slovak' },
  { id: 'sv', name: 'supportedLanguages:languages.swedish' },
  { id: 'tr', name: 'supportedLanguages:languages.turkish' },
  { id: 'th', name: 'supportedLanguages:languages.thai' },
];

export const getSupportedLanguagesInAlphabetOrder = (t: TFunction): IApiEntity[] => {
  const ordered: IApiEntity[] = [...SUPPORTED_LANGUAGES.slice(0, 11)];
  ordered.push(
    ...SUPPORTED_LANGUAGES.slice(11).sort((a, b: IApiEntity) => {
      if (t(a.name) === t(b.name)) return 0;
      return t(a.name) < t(b.name) ? -1 : 1;
    }),
  );
  return ordered;
};
